<template>
    <div class="main">
        <div class="selectorArea">
            <div class="selectorItemWrap" @click="changeSelector(0)">
                <div class="text">HEALTHCARE</div>
                <div v-if="this.selectorIndex == 0" class="selectedDash"></div>
            </div>
            <div class="split"></div>
            <div class="selectorItemWrap" @click="changeSelector(1)">
                <div class="text">SUPPLEMENTS</div>
                <div v-if="this.selectorIndex == 1" class="selectedDash"></div>
            </div>
            <div class="split"></div>
            <div class="selectorItemWrap" @click="changeSelector(2)">
                <div class="text">MEDICINE</div>
                <div v-if="this.selectorIndex == 2" class="selectedDash"></div>
            </div>
        </div>
        <div class="listArea">
            <div v-for="item, index in changeNowList()" :key="item.id" :class="(index + 1) % 3 == 0 ? 'itemWrapEnd' : 'itemWrap'" @click="toPage(item.url)" @mouseenter="this.showMask(item.id)" @mouseleave="this.hidewMask(item.id)">
                <div class="picWrap">
                    <img :src="item.pic" alt="" class="background">
                    <img :id="`mask-${item.id}`" src="../assets/products/mask.webp" alt="" class="mask">
                </div>
                <div class="brand" :id="`brand-${item.id}`">{{ item.brand }}</div>
                <div class="name">{{ item.name }}</div>
                <div class="brief">{{ item.brief }}</div>
            </div>
        </div>
        <page-footer></page-footer>
    </div>
    
</template>

<script>
import uniqueId from "lodash.uniqueid";
import PageFooter from "./PageFooter.vue";

export default {
    components: {
        PageFooter,
    },

    data() {
        return {
            selectorIndex: 0,
            healthcareList: [
                {
                    id: uniqueId("healthcare-"),
                    pic: require("../assets/products/healthcare/0.webp"),
                    brand: "Dr. TEST",
                    name: "Hematuria/Blood Detector",
                    brief: "Quickly identify hematuria/occult blood in cat urine for early detection of feline urinary tract disease.",
                    url: "/products/healthcare/healthcare_0"
                },
                {
                    id: uniqueId("healthcare-"),
                    pic: require("../assets/products/healthcare/3.webp"),
                    brand: "Felizone",
                    name: "Cat Pheromone Diffuser",
                    brief: "For cats with stress reactions and emotional problems caused by changes in the environment and other factors.",
                    url: "/products/healthcare/healthcare_3"
                },
                {
                    id: uniqueId("healthcare-"),
                    pic: require("../assets/products/healthcare/4.webp"),
                    brand: "Felizone",
                    name: "Cat Pheromone Spray",
                    brief: "For cats with stress reactions and emotional problems caused by changes in the environment and other factors.",
                    url: "/products/healthcare/healthcare_4"
                },
                {
                    id: uniqueId("healthcare-"),
                    pic: require("../assets/products/healthcare/6.webp"),
                    brand: "Allerfre",
                    name: "Cat Allergen Neutralizing Spray",
                    brief: "For the removal of allergens from cat saliva, dander and hair in the pet's living environment.",
                    url: "/products/healthcare/healthcare_6"
                },
            ],
            supplementsList: [
                {
                    id: uniqueId("supplements-"),
                    pic: require("../assets/products/supplements/0.webp"),
                    brand: "Allerfre",
                    name: "Cat Allergen Neutralizing Tablets",
                    brief: "Reduce the secretion and release of allergens in cats.",
                    url: "/products/supplements/supplement_0"
                },
                {
                    id: uniqueId("supplements-"),
                    pic: require("../assets/products/supplements/1.webp"),
                    brand: "Allvita",
                    name: "Intestinal Shield Paste",
                    brief: "Helps regulating intestinal function and protecting the gastrointestinal mucosa",
                    url: "/products/supplements/supplement_1"
                },
                {
                    id: uniqueId("supplements-"),
                    pic: require("../assets/products/supplements/2.webp"),
                    brand: "Allvita",
                    name: "Urinary Support Tablets",
                    brief: "Helps maintaining the normal function of the urinary tract",
                    url: "/products/supplements/supplement_2"
                },
            ],
            medicineList: [
                {
                    id: uniqueId("medicine-"),
                    pic: require("../assets/products/medicine/0.webp"),
                    brand: "NEXFLUR",
                    name: "Fluralaner Chewable Tablets",
                    brief: "12 weeks of irresistible protection against fleas, ticks, and mites",
                    url: "/products/medicine/medicine_0"
                },
                {
                    id: uniqueId("medicine-"),
                    pic: require("../assets/products/medicine/1.webp"),
                    brand: "Moxispot",
                    name: "Imidacloprid and Moxidectin Spot-on Solutions",
                    brief: "1 month of protection against endoparasites and ectoparasites",
                    url: "/products/medicine/medicine_1"
                },
                {
                    id: uniqueId("medicine-"),
                    pic: require("../assets/products/medicine/2.webp"),
                    brand: "Deltashield",
                    name: "Deltamethrin Collar",
                    brief: "6 months of protection against ticks",
                    url: "/products/medicine/medicine_2"
                },
            ],
        }
    },

    methods: {
        changeSelector(index) {
            // this.selectorIndex = index
            if (index == 0) {
                this.$router.push("/products/healthcare")
            }
            else if (index == 1) {
                this.$router.push("/products/supplements")
            }
            else if (index == 2) {
                this.$router.push("/products/medicine")
            }
        },
        changeNowList() {
            if (this.selectorIndex == 0) {
                return this.healthcareList
            }
            else if (this.selectorIndex == 1) {
                return this.supplementsList
            }
            else if (this.selectorIndex == 2) {
                return this.medicineList
            }
        },
        showMask(id) {
            window.$(`#mask-${id}`).css("opacity", "100%")
            window.$(`#brand-${id}`).css("color", "#FFA301")
        },
        hidewMask(id) {
            window.$(`#mask-${id}`).css("opacity", "0")
            window.$(`#brand-${id}`).css("color", "#1A1A1A")
        },
        toPage(newPath) {
            this.$router.push(newPath)
        },
    },
    mounted() {
        // var that = this
        var nowLastPath = this.$route.path.match(/\/{1}[\w]*$/g)[0]
        if (nowLastPath == "/healthcare") {
            this.selectorIndex = 0
        }
        else if (nowLastPath == "/supplements") {
            this.selectorIndex = 1
        }
        else if (nowLastPath == "/medicine") {
            this.selectorIndex = 2
        }
        this.$watch(
            () => this.$route.params.pageName,
            (newName) => {
                if (newName == "healthcare") {
                    this.selectorIndex = 0
                }
                else if (newName == "supplements") {
                    this.selectorIndex = 1
                }
                else if (newName == "medicine") {
                    this.selectorIndex = 2
                }
            }
        )
    },

}
</script>

<style scoped lang="scss">
.main {
  padding-top: $navBarHeight;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.selectorArea {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 3.8rem;
    padding: 0 $screenPadding;
    background-color: #E5E5E5;

    .split {
        height: 42%;
        width: 1px;
        background-color: #2C2B2B;
        margin: 0 4rem;
    }

    .selectorItemWrap {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        // margin: 0 4%;
        line-height: 100%;
        width: 11rem;
        cursor: pointer;

        .text {
            font-size: 1.2rem;
            color: #2C2B2B;
            font-weight: 600;
            font-family: "Montserrat", serif;
            // letter-spacing: 0.05rem;
        }

        .selectedDash {
            position: absolute;
            bottom: 0.4rem;
            background-color: $mainColor;
            height: 0.4rem;
            width: 100%;
            border-radius: 0.2rem;
        }
    }
}

.listArea {
    width: 100%;
    padding: 0 $screenPadding;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    padding-top: 4rem;
    margin-bottom: 5rem;

    .itemWrap {
        margin-right: 1.5%;
    }

    .itemWrap, .itemWrapEnd {
        width: 32.3%;
        display: flex;
        flex-direction: column;
        align-items: start;
        margin-bottom: 2.6rem;
        cursor: pointer;

        .picWrap {
            width: 100%;
            height: auto;
            position: relative;
            cursor: pointer;

            .background {
                width: 100%;
                height: auto;
                display: block;
            }

            .mask {
                width: 100%;
                height: 100%;
                z-index: 10;
                position: absolute;
                top: 0;
                left: 0;
                transition: opacity 0.3s ease;
                opacity: 0;
            }
        }

        .brand {
            font-size: 1.6rem;
            font-weight: 600;
            color: #1A1A1A;
            margin-top: 1rem;
            transition: color 0.3s ease;
            font-family: "Montserrat", serif;
            font-weight: 700;
        }

        .name {
            font-size: 1.6rem;
            font-weight: 600;
            color: #1A1A1A;
            font-family: "Montserrat", serif;
            font-weight: 700;
            // margin-top: 0.5rem;
        }

        .brief {
            font-size: 1.2rem;
            font-weight: 500;
            color: #646465;
            margin-top: 0.8rem;
            font-family: "Montserrat", serif;
            font-weight: 500;
            line-height: 1.8rem;
        }
    }
}

@media (max-width: 768px) {
    .main {
        padding-top: 4rem;
    }

    .selectorArea {
        padding: 0;
        justify-content: space-around;
        height: 3.4rem;
        
        .split {
            display: none;
        }
        
        .selectorItemWrap {
            width: 33%;
            flex: none;
            padding: 0;
            
            .text {
                font-size: 0.8rem;
                white-space: nowrap;
                width: 100%;
                text-align: center;
            }

            .selectedDash {
                bottom: 0;
                height: 0.3rem;
            }
        }
    }
    
    .listArea {
        padding: 0 1.5rem;
        padding-top: 2rem;
        
        .itemWrap, .itemWrapEnd {
            width: 100%;
            margin-right: 0;
            margin-bottom: 3rem;
            
            // Mobile Card Styles
            background-color: #FFFFFF;
            border-radius: 0.8rem;
            box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.08);
            overflow: hidden;
            padding-bottom: 2rem;
            transition: all 0.3s ease;
            
            &:hover {
                transform: translateY(-0.3rem);
                box-shadow: 0 0.8rem 2rem rgba(0, 0, 0, 0.12);
            }

            .brand {
                font-size: 1.4rem;
                margin-top: 1.5rem;
                padding: 0 1.5rem;
                width: 100%;
            }

            .name {
                font-size: 1.4rem;
                padding: 0 1.5rem;
                width: 100%;
            }

            .brief {
                font-size: 1rem;
                line-height: 1.5rem;
                padding: 0 1.5rem;
                width: 100%;
            }
        }
    }
}
</style>